// removed by extract-text-webpack-plugin
module.exports = {"InfoIcon":"InfoIcon__1xO1Q0e0Uvyo","corner":"corner__3PzE7BVeu5ov"};